// src/components/LocalisationAutocomplete.js

import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";

/**
 * LocalisationAutocomplete Component:
 * Provides an autocomplete input for localization with both selection and free text entry.
 *
 * Props:
 * - value: The current value of the input.
 * - onChange: Function to handle changes to the input value.
 */
const LocalisationAutocomplete = ({ value, onChange }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchLocalisationData = async () => {
      setLoading(true);
      try {
        const response = await axios.get("/localisations.xml", {
          headers: { "Content-Type": "application/xml" },
        });

        const parser = new DOMParser();
        const xml = parser.parseFromString(response.data, "application/xml");
        const localisationNodes = xml.getElementsByTagName("localisation");

        const localisations = Array.from(localisationNodes).map(
          (node) => node.textContent
        );

        setOptions(localisations);
      } catch (error) {
        console.error("Error fetching localisation data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLocalisationData();
  }, []);

  return (
    <Autocomplete
      freeSolo
      options={options}
      value={value}
      onChange={(event, newValue) => {
        onChange(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        // updates when user is typing 
        if (event && event.type === "change") {
          onChange(newInputValue);
        }
      }}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Localisation"
          variant="outlined"
          fullWidth
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          sx={{
            //background: "linear-gradient(135deg,rgb(229, 242, 248),rgb(209, 232, 243))", // Updated background
            borderRadius: "10px",
          }}
        />
      )}
    />
  );
};

export default LocalisationAutocomplete;
